import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
  FetchPageContentAction,
  FetchPageContentFailedAction,
  FetchPageContentSuccessAction,
  PageContentActionTypes,
} from './page-content.actions';
import { PageResourceService } from './page-resource.service';

@Injectable()
export class PageContentEffects {
  fetchPageContent$: Observable<
    FetchPageContentSuccessAction | FetchPageContentFailedAction
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(PageContentActionTypes.FETCH_PAGE_CONTENT),
      mergeMap((action: FetchPageContentAction) => {
        const { pageId } = action.payload;
        return this.pageResourceService.getPageResource(pageId).pipe(
          map(
            pageContent =>
              new FetchPageContentSuccessAction({
                pageContent,
                pageId,
              }),
          ),
          catchError(error =>
            observableOf(new FetchPageContentFailedAction({ error, pageId })),
          ),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private pageResourceService: PageResourceService,
  ) {}
}
